import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/header";

function Welcome() {
  return (
    <>
      <Header />
      <h2>Welcome buddy!</h2>
      <Link to="/editor/new1">Try the new image editor!</Link>
    </>
  );
}

export default Welcome;
